import React from 'react';
import { Tabs as MuiTabs, Tab as MuiTab } from '@mui/material';
import { acme } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export const acmeTabsSx = {
  minHeight: 44,
  borderBottom: `1px solid ${acme.colors.border}`,
  '& .MuiTabs-indicator': {
    height: 2,
    backgroundColor: acme.colors.foreground,
    borderRadius: 1,
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '0.875rem',
    color: acme.colors.mutedForegroundSolid,
    minHeight: 44,
    '&.Mui-selected': {
      color: acme.colors.foreground,
      fontWeight: 600,
    },
    '&:hover': {
      color: acme.colors.foreground,
    },
  },
};

export function Tabs({ sx, children, ...props }) {
  return (
    <MuiTabs sx={mergeSx(acmeTabsSx, sx)} {...props}>
      {children}
    </MuiTabs>
  );
}

export function Tab(props) {
  return <MuiTab disableRipple {...props} />;
}

Tabs.Tab = Tab;

export default Tabs;
